import { render, staticRenderFns } from "./detailResource.vue?vue&type=template&id=32d5e843"
import script from "./detailResource.vue?vue&type=script&lang=js"
export * from "./detailResource.vue?vue&type=script&lang=js"
import style0 from "./detailResource.vue?vue&type=style&index=0&id=32d5e843&prod&lang=less"
import style1 from "./detailResource.vue?vue&type=style&index=1&id=32d5e843&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports